import {Alert, Button, Card, notification, Popconfirm, Table} from "antd";
import React, {useContext, useEffect, useState} from "react";
import {ColumnsType, TableProps} from "antd/es/table";
import Colors from "../../../styles/Colors";
import {BiArrowBack, BiPencil, BiPlus, BiRefresh, BiTrash} from "react-icons/bi";
import AlumneCasal from "../../../model/inscripcions/AlumneCasal";
import {PostInscripcionsInscripcioSwitch} from "../../../dao/inscripcions/PostInscripcionsInscripcioSwitch";
import {useParams} from "react-router-dom";
import {AuthContext} from "../../../config/AuthContext";
import {GetInscripcionsIdInfants} from "../../../dao/inscripcions/GetInscripcionsIdInfants";
import InfantModal from "./InfantModal";
import {PostInscripcioInfant} from "../../../dao/inscripcions/PostInscripcioInfant";
import toast, {Toaster} from "react-hot-toast";
import {QuestionCircleOutlined} from "@ant-design/icons";
import {NotificationPlacement} from "antd/es/notification/interface";

interface element {
    id_inscripcio: string,
    page: string,
    goBack: () => void,
    checkInfants: (value: boolean) => void,

}

const Infants = (props: element) => {

    const [autoritzats, setAutoritzats] = useState<AlumneCasal[]>([]);
    const [api, contextHolder] = notification.useNotification();

    const {id_inscripcio} = useParams();
    const [visible, setVisible] = useState(false);
    const [coleccio, setDades] = useState<AlumneCasal[]>([]);
    const [loading, setLoading] = useState(false);

    const {isLoggedIn, userId, user, page, userDni, userCognom} = useContext(AuthContext);
    const [nouElement, setNouElement] = useState(false);
    const [elementSelected, setElementSelected] = useState<AlumneCasal>(new AlumneCasal());

    const openNotification = (placement: NotificationPlacement) => {
        api.info({
            message: `Notification ${placement}`,
            description:
                'This is the content of the notification. This is the content of the notification. This is the content of the notification.',
            placement,
        });
    };

    useEffect(() => {
        checkDades();
    }, []);


    const tableProps: TableProps<AlumneCasal> = {
        loading
    };

    const onChange: TableProps<AlumneCasal>['onChange'] =
        (pagination,
         filters,
         sorter,
         extra) => {
            //console.log('params', pagination, filters, sorter, extra);
        };


    const handleLoadingChange = (enable: boolean) => {
        setLoading(enable);
    };

    async function checkDades() {
        handleLoadingChange(true)
        const dades = await GetInscripcionsIdInfants(props.id_inscripcio + "", props.page);
        setAutoritzats(dades);
        props.checkInfants(dades.length > 0);
        //console.log(JSON.stringify(dades));
        handleLoadingChange(false);
    }

    async function deleteElement(data: AlumneCasal) {
        const newData = {...data, estat: -1};
        await PostInscripcioInfant(newData, id_inscripcio + "", page);
        //openNotification('top');
        toast.success('Eliminat');
        await checkDades();

    }

    function afegirElement(element: AlumneCasal) {
        setNouElement(!nouElement);
        setVisible(true);
        setElementSelected(element);
    }

    function togleNouElement(element: AlumneCasal) {
        setNouElement(!nouElement);
        setVisible(true);
        setElementSelected(element);
    }

    const columns: ColumnsType<AlumneCasal> = [
        {
            key: 'nom',
            title: 'Nom',
            dataIndex: 'nom',
            filterSearch: true,
            fixed: 'left',
            width: 50,
            render: (estat, ele) => (
                <>{ele.nom}{" "}{ele.cognoms}</>
            ),
        },
        {
            key: 'data_naix',
            title: 'Data de Naixement',
            dataIndex: 'data_naix',
            width: 50,
            filterSearch: true,
        },
        {
            key: 'modificacio',
            title: 'Data de modificació',
            dataIndex: 'modificacio',
            width: 50,
            filterSearch: true,
        },
        {
            key: 'accions', title: 'Accions', dataIndex: 'accions', width: 50,
            render: (estat, ele) => (
                <>
                    <Button title={"Modificar"} style={{backgroundColor: Colors.colors.color6}}
                            onClick={() => togleNouElement(ele)}><BiPencil/></Button>{" "}
                    <Popconfirm
                        title="Eliminant"
                        description="Vols eliminar definitivament aquest element?"
                        onConfirm={() => deleteElement(ele)}
                        icon={<QuestionCircleOutlined style={{color: 'red'}}/>}
                    >
                        <Button title={"Eliminar"} style={{backgroundColor: Colors.colors.color5}}><BiTrash/></Button>
                    </Popconfirm>
                </>
            ),
        },
    ];

    function onClose(valor: boolean) {
        checkDades();
        setVisible(false);
    }

    return (
        <>
            <div className={"actionButtons"}>
                <Button title={"Sortir"} style={{backgroundColor: Colors.colors.color4}} onClick={() =>
                    props.goBack()}><BiArrowBack/> SORTIR</Button>{" "}
                <Button title={"Refrescar"} style={{backgroundColor: Colors.colors.color5}} onClick={() =>
                    checkDades()}><BiRefresh/> REFRESCAR</Button>{" "}
                <Button title={"Editar"} style={{backgroundColor: Colors.colors.color6}} onClick={() =>
                    afegirElement(new AlumneCasal())}><BiPlus/> AFEGIR INFANT</Button>
            </div>
            <h4 className={"titol"}>{"INFANTS"}</h4>
            <Card bordered={true} className={"elemento"}>
                <Alert
                    message={"Modifiqueu les dades només d'aquells infants que es vol fer inscripció i afegiu els que no hi son"}
                    type={"warning"}/>
                <Table
                    {...tableProps}
                    onChange={onChange}
                    columns={columns}
                    scroll={{y: 240}}
                    dataSource={autoritzats}
                />
            </Card>
            <Toaster/>
            {visible && <InfantModal element={elementSelected} visible={visible} onClose={onClose} page={props.page}/>}
        </>
    );

};

export default Infants;